module.exports = __webpack_public_path__ + "img/checkin.6caf85f1.png";